import type {
    CommercialActivityStatsViewModel,
  PaginationOffsetResponseModel_GetRepartitionVisitesViewModel,
  PaginationOffsetResponseModel_VisiteDetailViewModel,
} from '@/lib/types'
import baseRepository from '@/repository/BaseRepository.ts'
import {getStoredEndDate, getStoredStartDate} from '@/lib/localStorage.ts'

export default {
  async getInfoCardData(): Promise<CommercialActivityStatsViewModel> {
    const url = await baseRepository.buildUrl(`api/commercial/infocard?start_date=${getStoredStartDate()}&end_date=${getStoredEndDate()}`)
    return baseRepository.fetchData<CommercialActivityStatsViewModel>(url)
  },
  async getTableData(
      skip: number,
      take: number,
      sort_field: string = '',
      sort_order: 'asc' | 'desc',
  ): Promise<PaginationOffsetResponseModel_GetRepartitionVisitesViewModel> {
      const params = {
      offset: skip.toString(),
      limit: take.toString(),
      order_by: sort_field,
      order_direction: sort_order,
      }
      const url = await baseRepository.buildUrl(
      `api/commercial/repartition-visites-table?start_date=${getStoredStartDate()}&end_date=${getStoredEndDate()}`,
      params,
      )
      return baseRepository.fetchData<PaginationOffsetResponseModel_GetRepartitionVisitesViewModel>(url)
  },
  async downloadExcel(): Promise<void> {
    await baseRepository.downloadExcelFile(
      `api/widgets/card-details-clients/${getStoredEndDate()}/excel`,
      `clients_${getStoredEndDate()}.xlsx`,
    )
  },

  async getTableDetailsData(
    commercialId: number,
    skip: number,
    take: number,
    sort_field: string = '',
    sort_order: 'asc' | 'desc',
  ): Promise<PaginationOffsetResponseModel_VisiteDetailViewModel> {
    const params = {
      offset: skip.toString(),
      limit: take.toString(),
      order_by: sort_field,
      order_direction: sort_order,
      start_date: getStoredStartDate(),
      end_date: getStoredEndDate(),
    }
    const url = await baseRepository.buildUrl(
      `api/commercial/repartition-visites-table/${commercialId}/details`,
      params,
    )
    return baseRepository.fetchData<PaginationOffsetResponseModel_VisiteDetailViewModel>(url)
  }
}
